<script setup lang="ts">
    import { getErrorMessage } from "@/api";
    import { Option } from "@/components/forms/inputs/Autocomplete/types";
    import { convertResursData, Resurs } from "@/components/forms/reusables/resurserHelper";
    import { useStore } from "@/store";
    import { openDialog } from "@/utils";
    import { toRefs } from "vue";

    interface Props {
        onlyActive?: boolean;
    }
    const props = withDefaults(defineProps<Props>(), {
        onlyActive: true,
    });
    const { onlyActive } = toRefs(props);

    const store = useStore();

    const fetchResurser = async ({ query }: { query?: string } = {}) => {
        const params: {
            totalt_antal__gte: number;
            q?: string;
        } = {
            totalt_antal__gte: onlyActive.value ? 1 : 0,
        };

        if (query) {
            params.q = query;
        }

        try {
            const { results, subsetName } = await store.dispatch("resurs/fetchResurser", {
                filterParams: params,
            });
            const items: Resurs[] =
                results ?? store.getters["resurs/resursSubset"]({ subsetName, offset: 0, limit: 0 });
            return items.map((resurs: Resurs) => convertResursData({ resurs }));
        } catch (e) {
            console.error(e);
            openDialog("Kunde inte hämta resurser. " + getErrorMessage(e), "warning");
        }
    };

    const converterResurser = ({ value }: { value: { id: string | Option; [key: string]: unknown }[] }) => {
        return value.map(({ id }) => {
            if (typeof id === "object") {
                return (id as Option).value;
            }

            return id;
        });
    };
</script>

<template>
    <KRepeater
        name="resurser"
        add-label="Lägg till resurs"
        remove-label="Ta bort resurs"
        :converter="converterResurser"
        #default="{ index, model }"
    >
        <KAutocomplete
            name="id"
            label="Resurs"
            class="span-all"
            :onSearch="fetchResurser"
            :value="model?.[index]?.id ?? null"
            :options="fetchResurser"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
